export enum RevealContentStates {
    MORE = 'more',
    LESS = 'less'
}
